"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Buttons = void 0;

Buttons = function () {
  function Buttons() {
    $(".multi-step").on("click", function (e) {
      var $this = void 0;
      var nextStep = void 0;
      e.preventDefault();
      $this = $(this);
      nextStep = $this.attr("href");
      if ($(nextStep).length > 0) {
        $(this).removeClass("visible").addClass("hidden");
        return $(nextStep).removeClass("hidden").addClass("visible");
      } else {
        return window.location = nextStep;
      }
    });
    $(".button.button-process").on("click", function (e) {
      var $this = void 0;
      $this = $(this);
      $this.toggleClass("processing");
      return setTimeout(function () {
        $this.removeClass("processing").addClass("success");
        return setTimeout(function () {
          return $this.removeClass("success");
        }, 3000);
      }, 10000);
    });
  }

  return Buttons;
}();

exports.default = Buttons;